(() => {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const announce = (message) => {
    let live = qs('[data-hv-live]');
    if (!live) {
      live = document.createElement('div');
      live.className = 'hv-live-region';
      live.dataset.hvLive = '';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = message;
  };

  const updateCartCount = async () => {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      qsa('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    } catch (error) {
      // A blocked cart request should not stop normal theme navigation.
    }
  };

  const initPlanForms = () => {
    qsa('form.hv-plan-form').forEach((form) => {
      if (form.dataset.hvBound === 'true') return;
      form.dataset.hvBound = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = qs('button[type="submit"]', form);
        if (!button || button.disabled) return;
        const label = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding…';
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error('Unable to add item');
          await response.json();
          await updateCartCount();
          announce('Added to cart.');
          button.textContent = 'Added ✓';
          window.setTimeout(() => { button.textContent = label; button.disabled = false; }, 1800);
        } catch (error) {
          button.textContent = label;
          button.disabled = false;
          announce('The item could not be added. Please try again.');
        }
      });
    });
  };

  const initShopScroll = () => {
    const target = qs('#plans');
    const triggers = qsa('[data-scroll-to-plans]');
    if (!target || !triggers.length) return;
    const focusElement = (element) => {
      element.classList.remove('is-scroll-focused');
      void element.offsetWidth;
      element.classList.add('is-scroll-focused');
      window.setTimeout(() => element.classList.remove('is-scroll-focused'), 1800);
    };
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        const firstProduct = qs('.hv-plan-card', target);
        if (!firstProduct) return;
        event.preventDefault();
        focusElement(trigger);
        focusElement(firstProduct);
        const visibleGap = Math.max(24, (window.innerHeight - firstProduct.getBoundingClientRect().height) / 2);
        const scrollTop = Math.max(0, firstProduct.getBoundingClientRect().top + window.scrollY - visibleGap);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: scrollTop, behavior: reducedMotion ? 'auto' : 'smooth' });
        if (!firstProduct.hasAttribute('tabindex')) firstProduct.setAttribute('tabindex', '-1');
        window.setTimeout(() => firstProduct.focus({ preventScroll: true }), reducedMotion ? 0 : 550);
      });
    });
  };

  const initFaq = () => {
    qsa('.hv-faq-item').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        qsa('.hv-faq-item[open]').forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });
  };

  const initExpertDialog = () => {
    const dialog = qs('[data-expert-dialog]');
    const video = qs('[data-expert-dialog-video]');
    const title = qs('[data-expert-dialog-title]');
    if (!dialog || !video) return;
    let restoreFocus = null;
    const close = () => {
      video.pause();
      video.removeAttribute('src');
      video.load();
      if (dialog.open) dialog.close();
      if (restoreFocus) restoreFocus.focus();
    };
    qsa('[data-expert-video]').forEach((card) => {
      card.addEventListener('click', () => {
        restoreFocus = card;
        video.src = card.dataset.expertVideo || '';
        title.textContent = card.dataset.expertTitle || 'Expert video';
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        video.play().catch(() => {});
      });
    });
    qsa('[data-dialog-close]').forEach((button) => button.addEventListener('click', close));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); });
    dialog.addEventListener('cancel', close);
  };

  const initReviewVideos = () => {
    qsa('[data-review-video]').forEach((card) => {
      const video = qs('video', card);
      if (!video) return;
      video.play().catch(() => {});
      card.addEventListener('click', () => {
        qsa('[data-review-video]').forEach((other) => {
          const otherVideo = qs('video', other);
          if (other === card) return;
          if (otherVideo) {
            otherVideo.muted = true;
            other.classList.remove('is-unmuted');
            other.setAttribute('aria-pressed', 'false');
          }
        });
        video.muted = !video.muted;
        card.classList.toggle('is-unmuted', !video.muted);
        card.setAttribute('aria-pressed', String(!video.muted));
        announce(video.muted ? 'Review video muted.' : 'Review video sound on.');
      });
    });
  };

  const initVotes = () => {
    qsa('[data-vote]').forEach((button) => {
      button.addEventListener('click', () => {
        const card = button.closest('.hv-review-card');
        if (!card) return;
        qsa('[data-vote]', card).forEach((vote) => vote.classList.remove('is-voted'));
        button.classList.add('is-voted');
        announce('Thanks for your feedback.');
      });
    });
  };

  const init = () => {
    initPlanForms();
    initShopScroll();
    initFaq();
    initExpertDialog();
    initReviewVideos();
    initVotes();
    updateCartCount();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
